import { Box, Button, OsModal } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { AvatarImage, COMMON_AVATARS } from "@outschool/ui-components-shared";
import React from "react";

interface PickLearnerAvatarModalProps {
  unlockedAvatars?: string[];
  open?: boolean;
  onSelect: (s: string) => void;
  onCancel: () => void;
  headingText?: string;
  cancelText?: string;
}

export default function PickLearnerAvatarModal({
  unlockedAvatars = [],
  open = true,
  onSelect,
  onCancel,
  headingText = "Select avatar",
  cancelText = "Cancel",
}: PickLearnerAvatarModalProps) {
  //add the unlocked avatars to the deafult avatar list for full avatar list for current child
  const allAvatars = COMMON_AVATARS.concat(unlockedAvatars);

  return (
    <OsModal
      open={open}
      onClose={onCancel}
      title={headingText}
      actionSecondary={<Button onClick={onCancel}>{cancelText}</Button>}
    >
      <Box
        sx={{
          marginTop: "0.5em",
          marginBottom: "0.5em",
        }}
      >
        {allAvatars.map(avatar => (
          <AvatarImage
            key={avatar}
            avatar={avatar}
            height={50}
            width={50}
            sx={{ cursor: "pointer" }}
            onClick={() => onSelect(avatar)}
          />
        ))}
      </Box>
    </OsModal>
  );
}
